
/**
 * @file guide card
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import guideCard from '../../asset/img/appeal/guide_card.png';
import {recordProxy} from '../../util';
import './index.less';
const GuideCard = (props) => {
    const {
        title,
        url
    } = props;
    const history = useHistory();

    const onButtonClick = () => {
        recordProxy('url-' + url.replace('/', ''), 'click', '了解更多');
        history.push(url);
    };
    return (
        <div className="guide-card">
            <div className="guide-card-container">
                <p className="title">{title}</p>
                <p className="title-tip">永远告别恶意标记，大幅提高外呼接通率</p>
                <Button
                    className="btn"
                    onClick={onButtonClick}
                >
                    了解更多
                </Button>
                <img src={guideCard}></img>
            </div>
        </div>
    );
};

GuideCard.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string
};

export default withRouter(GuideCard);
